import { createAsyncThunk } from '@reduxjs/toolkit';
import { filteredDataWindow } from 'api/footer/service';

export const filteredDataWindowThunk = createAsyncThunk('data/filteredDataWindowThunk', async (workspaceId: string, thunkAPI, ) => {
    const response = await filteredDataWindow(workspaceId, thunkAPI)
    return response
});

